export const clientLogos = [
  { src: 'https://quest-media-storage-bucket.s3.us-east-2.amazonaws.com/1766172370358-Happyfresh.png', alt: 'Happyfresh' },
  { src: 'https://quest-media-storage-bucket.s3.us-east-2.amazonaws.com/1766172373989-Bang%20Jamin.png', alt: 'Bang Jamin' },
  { src: 'https://quest-media-storage-bucket.s3.us-east-2.amazonaws.com/1766172379092-Kovr.ai.png', alt: 'Kovr.ai' },
  { src: 'https://quest-media-storage-bucket.s3.us-east-2.amazonaws.com/1766172383230-Indozone.png', alt: 'Indozone' },
  { src: 'https://quest-media-storage-bucket.s3.us-east-2.amazonaws.com/1766172388197-Pyng.png', alt: 'Pyng' }
];

export const services = [
  {
    name: 'UI/UX Design',
    description: 'User-centered design that drives engagement and conversions through intuitive interfaces and seamless experiences.',
    image: 'https://cdn.dribbble.com/userupload/46097111/file/881bc43c6642105bb65ad39a8135d7e8.png'
  },
  {
    name: 'Web Design/Development',
    description: 'High-performance websites built for scale, optimized for conversions and designed to grow with your business.',
    image: 'https://cdn.dribbble.com/userupload/45838200/file/a717c89149b18b4823d02e2f5acfa721.png'
  },
  {
    name: 'Conversion Rate Optimization',
    description: 'Data-driven optimization to maximize revenue through strategic design improvements and user behavior analysis.',
    image: 'https://53.fs1.hubspotusercontent-na1.net/hubfs/53/conversion-rate-optimization-5-20240905-3996251.webp'
  },
  {
    name: 'Product Strategy',
    description: 'Strategic roadmaps that align design with business goals, ensuring every design decision drives measurable results.',
    image: 'https://www.romanpichler.com/wp-content/uploads/2022/08/Romans-product-strategy-model-2022.png'
  },
  {
    name: 'Design Systems',
    description: 'Scalable design systems for consistent product experiences that accelerate development and maintain quality.',
    image: 'https://cdn.dribbble.com/userupload/3797389/file/original-e03b0662fd7ebb9cafbd61adfb9121db.png'
  }
];

export const caseStudies = [
  {
    client: 'Saturdays.com',
    title: 'E-commerce platform redesign',
    description: 'Revamped the digital flagship for Indonesia leading lifestyle eyewear brand, focusing on virtual try-on and seamless checkout.',
    image: 'https://products.cdn.saturdays.com/about-us/feature-app.webp',
    logo: '/images/clients/saturdays.svg',
    metrics: [
      { value: 45, suffix: '%', label: 'Conversion ↑' },
      { value: 30, suffix: '%', label: 'Bounce Rate ↓' },
      { value: 2, suffix: 'M+', label: 'Revenue Impact' }
    ]
  },
  {
    client: 'Happyfresh',
    title: 'Grocery delivery app optimization',
    description: 'Streamlined the checkout flow and search experience for Southeast Asia premier grocery delivery service.',
    image: 'https://quest-media-storage-bucket.s3.us-east-2.amazonaws.com/1766212838996-blob',
    logo: 'https://quest-media-storage-bucket.s3.us-east-2.amazonaws.com/1766172370358-Happyfresh.png',
    metrics: [
      { value: 60, suffix: '%', label: 'User Retention ↑' },
      { value: 40, suffix: '%', label: 'Orders ↑' },
      { value: 25, suffix: '%', label: 'Cart Abandonment ↓' }
    ]
  },
  {
    client: 'Kovr.ai',
    title: 'AI platform UI/UX design',
    description: 'Designed the complex dashboard interface for an AI-driven cyber risk management platform used by enterprise insurers.',
    image: 'https://kovr.ai/wp-content/uploads/2025/05/kovr-screen.jpg',
    logo: 'https://quest-media-storage-bucket.s3.us-east-2.amazonaws.com/1766172379092-Kovr.ai.png',
    metrics: [
      { value: 3, suffix: 'x', label: 'User Growth' },
      { value: 50, suffix: '%', label: 'Engagement ↑' },
      { value: 1, suffix: '', label: 'Series A Funded' }
    ]
  },
  {
    client: 'Pyng',
    title: 'Fintech product design',
    description: 'Built the mobile-first identity and core transaction flows for a next-generation fintech payment solution.',
    image: 'https://cdn.prod.website-files.com/662f1d5b8594ae917a15daf2/68b580da1e6754f2918f0fd1_Link%20your%20account%20new.jpg',
    logo: 'https://quest-media-storage-bucket.s3.us-east-2.amazonaws.com/1766172388197-Pyng.png',
    metrics: [
      { value: 80, suffix: '%', label: 'Sign-ups ↑' },
      { value: 35, suffix: '%', label: 'Transactions ↑' },
      { value: 5, suffix: 'M', label: 'ARR' }
    ]
  }
];

export const frameworkStages = [
  {
    name: 'Discovery & Strategy',
    description: 'Understand your users, market, and business goals through comprehensive research and analysis.'
  },
  {
    name: 'Design Sprints',
    description: 'Rapid prototyping and iterative design cycles that move at startup speed.'
  },
  {
    name: 'Test & Iterate',
    description: 'Data-driven testing and continuous optimization based on real user feedback.'
  },
  {
    name: 'Scale & Systemize',
    description: 'Build scalable design systems for sustainable growth and consistent experiences.'
  }
];

export const testimonials = [
  {
    quote: 'Working with Arabica transformed our product. Their team embedded seamlessly and delivered results every single week. Our conversion rate doubled in 3 months.',
    name: 'Sarah Johnson',
    title: 'CEO',
    company: 'Saturdays.com',
    logo: '/images/clients/saturdays.svg'
  },
  {
    quote: 'Rohan and his team understand startup constraints. They move fast, iterate quickly, and always focus on what drives business impact.',
    name: 'Michael Chen',
    title: 'CTO',
    company: 'Happyfresh',
    logo: 'https://quest-media-storage-bucket.s3.us-east-2.amazonaws.com/1766172370358-Happyfresh.png'
  },
  {
    quote: 'The Rohan Mishra Framework is exactly what we needed. Clear process, weekly progress, and measurable results. Best design partnership we\'ve had.',
    name: 'Priya Sharma',
    title: 'Product Lead',
    company: 'Kovr.ai',
    logo: 'https://quest-media-storage-bucket.s3.us-east-2.amazonaws.com/1766172379092-Kovr.ai.png'
  },
  {
    quote: 'Arabica didn\'t just design our app - they helped us think through our entire user journey and CRO strategy. Game changer.',
    name: 'Alex Rodriguez',
    title: 'Founder',
    company: 'Pyng',
    logo: 'https://quest-media-storage-bucket.s3.us-east-2.amazonaws.com/1766172388197-Pyng.png'
  }
];

export const teamCapabilities = [
  {
    title: 'Design Experts',
    description: 'Senior UI/UX designers with 8+ years experience in startup environments',
    icon: 'Palette'
  },
  {
    title: 'CRO Specialists',
    description: 'Data-driven optimization experts who understand conversion psychology',
    icon: 'TrendingUp'
  },
  {
    title: 'Product Strategists',
    description: 'Strategic thinkers who align design with business goals and user needs',
    icon: 'Target'
  },
  {
    title: 'Development Partners',
    description: 'Technical implementation experts for flawless design-to-code execution',
    icon: 'Code'
  }
];

export const pricingFeatures = [
  'Retainer-based engagement',
  'Weekly or bi-weekly deliverables',
  'Dedicated design team',
  'All core services included',
  'UI/UX Design',
  'Web Design/Development',
  'Conversion Rate Optimization',
  'Product Strategy & Design Systems',
  'Direct founder access'
];